import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { cn } from '@/shared/lib/cn'

import { ActivityPanel } from './ActivityPanel'
import { NavRail } from './NavRail'
import { TopBar } from './TopBar'

/**
 * Il telaio: rail, contenuto, registro.
 *
 * Sotto i 1024px il rail diventa un pannello a scomparsa — un rail di sole
 * icone non avrebbe senso in un prodotto le cui voci si chiamano "Presentazione"
 * e "Amministratore", dove l'icona sarebbe un indovinello — e solo a quelle
 * larghezze compare una barra in alto, per il comando che lo apre.
 */
export function AppLayout() {
  const [activityOpen, setActivityOpen] = useState(false)
  const [navOpen, setNavOpen] = useState(false)
  const location = useLocation()

  // Cambiando pagina il pannello mobile si chiude: restare aperto sopra il
  // contenuto appena richiesto nasconderebbe proprio ciò che si è chiesto.
  useEffect(() => {
    setNavOpen(false)
  }, [location.pathname])

  return (
    <div className="flex h-dvh flex-col overflow-hidden">
      <a
        href="#contenuto"
        className="bg-bordeaux-500 text-white sr-only rounded-md px-4 py-2 focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50"
      >
        Vai al contenuto
      </a>

      <TopBar onOpenNav={() => setNavOpen(true)} />

      <div className="flex min-h-0 flex-1">
        <div className="hidden w-[var(--rail-width)] shrink-0 overflow-y-auto border-r border-[var(--hairline)] lg:block">
          <NavRail
            activityOpen={activityOpen}
            onToggleActivity={() => setActivityOpen((open) => !open)}
          />
        </div>

        {navOpen ? (
          <div className="fixed inset-0 z-40 lg:hidden">
            <button
              type="button"
              aria-label="Chiudi la navigazione"
              onClick={() => setNavOpen(false)}
              className="absolute inset-0 bg-black/60"
            />
            <div className="bg-ink-900 absolute inset-y-0 left-0 w-[var(--rail-width)] overflow-y-auto border-r border-[var(--hairline-strong)] shadow-[var(--shadow-lift)]">
              <NavRail
                onNavigate={() => setNavOpen(false)}
                activityOpen={activityOpen}
                onToggleActivity={() => setActivityOpen((open) => !open)}
              />
            </div>
          </div>
        ) : null}

        <main
          id="contenuto"
          className={cn('flex min-w-0 flex-1 flex-col overflow-y-auto')}
          tabIndex={-1}
        >
          <Outlet />
        </main>

        <ActivityPanel open={activityOpen} onClose={() => setActivityOpen(false)} />
      </div>
    </div>
  )
}
